import React, { useMemo, useState } from 'react';

// Components
import Portal from '../Portal/Portal';
import FaultedCyclesModal from '../FaultedCyclesModal/FaultedCyclesModal';

// Hooks
import useIsMobile from '../../hooks/useIsMobile';

// Types
import { FaultCheckableCycle, getFaultedCycleGroups } from '../../utils/getFaultedCycleGroup';

type ComponentProps = {
  cycles: FaultCheckableCycle[];
};

const FaultedCyclesButton: React.FC<ComponentProps> = ({ cycles }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isMobile = useIsMobile();

  const groups = useMemo(() => getFaultedCycleGroups(cycles), [cycles]);

  // The fixed full-width banner eats too much of the viewport on a phone
  // screen, so it's desktop/tablet-only there - the underlying fault data
  // is unaffected, this just hides the always-on-top nag banner.
  if (!groups.length || isMobile) {
    return null;
  }

  const faultCount = groups.reduce((total, group) => total + group.faults.length, 0);

  return (
    <>
      <Portal>
        <button
          type="button"
          onClick={() => setIsModalOpen(true)}
          className="fixed left-0 top-0 z-9999 w-full bg-red px-4 py-2.5 text-center text-sm font-bold text-white shadow-md transition-opacity hover:opacity-90"
        >
          {`⚠ Faulted cycles (${groups.length} cycle${groups.length === 1 ? '' : 's'}, ${faultCount} channel${faultCount === 1 ? '' : 's'}) - click for details`}
        </button>
      </Portal>
      <FaultedCyclesModal groups={groups} isVisible={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default FaultedCyclesButton;
